<template>
  <div>
    <Modal
      ref="modal"
      title="Add city"
      action="Save"
      action-color="indigo"
      @close-modal="handleCancel"
      @handle-action="handleCreate"
    >
      <GoogleMapsInput
        label="Location"
        :model-value="job.location"
        autocomplete-type="city"
        @update:model-value="job.location = $event"
      />
    </Modal>
  </div>
</template>

<script>
import Modal from '../shared/Modal.vue';
import StatesUtility from '../../utilities/states.js';
import GoogleMapsInput from '../shared/GoogleMapsInput.vue';
import { createJobLocation } from '../../api/jobs.ts';

export default {
  components: {
    Modal,
    GoogleMapsInput,
  },
  props: ['record'],
  data() {
    return {
      job: {
        location: {
          city: '',
          state: '',
          country: '',
          latitude: null,
          longitude: null,
        },
      },
      states: StatesUtility.getStates(),
    };
  },
  methods: {
    validateLocation() {
      const { city, state, country, latitude, longitude } = this.job.location;

      if (!city || !state) {
        this.$store.commit('general/showAlert', {
          alertType: 'error',
          alertTitle: 'Missing location data',
          alertDescription: 'Please select a valid city and state.',
        });
        return false;
      }

      if (!latitude || !longitude) {
        this.$store.commit('general/showAlert', {
          alertType: 'error',
          alertTitle: 'Missing coordinates',
          alertDescription: 'Please select a location from the dropdown to ensure coordinates are captured.',
        });
        return false;
      }

      return true;
    },
    async handleCreate() {
      // Validate location data before proceeding
      if (!this.validateLocation()) {
        return;
      }

      try {
        await createJobLocation(
          { id: this.record.id },
          {
            newJobLocationAttributes: {
              city: this.job.location.city,
              state: this.job.location.state,
              country: this.job.location.country || 'USA',
              latitude: this.job.location.latitude,
              longitude: this.job.location.longitude,
              status: 'active',
            },
          }
        );

        // Vue 3 compatible way to access and call the success method
        if (this.$refs.modal && typeof this.$refs.modal.success === 'function') {
          this.$refs.modal.success();
        } else {
          // Fallback if the success method is not available
          this.$store.commit('general/hideLocalLoadingSpinner');
        }

        // Emit the event only once, outside of the conditional block
        this.$emit('handleJobCityNewCreate');

        this.$store.commit('general/showAlert', {
          alertType: 'success',
          alertTitle: 'Job city added',
          alertDescription:
            'Your city was successfully added. Use the buttons below to view your job, or dismiss this alert.',
          alertUrl: `/jobs/${this.record.title}`,
        });
      } catch (error) {
        console.error('Error creating job location:', error);
        this.$store.commit('general/showAlert', {
          alertType: 'error',
          alertTitle: 'Error adding city',
          alertDescription: error.message || 'An error occurred while adding the city. Please try again.',
        });
      }
    },
    handleCancel() {
      this.$emit('handleJobCityNewCancel');
    },
  },
};
</script>
